<template>
	<div>
		<div v-if="loaders.detail_loader" style="position:absolute; top:0; right:0; bottom:0; left:45%; padding-top: 25%;background-color:rgba(255,255,255,0.31)">
	        <div class="text-xs-center">
	          <v-progress-circular
	              indeterminate
	              color="primary"
	              class="text-xs-center my-5"
	              large
	          ></v-progress-circular>
	        </div>
      	</div>
      	<v-container fluid grid-list-md v-else>
      		<v-layout row wrap>
      			<v-flex xs12 md12 lg12>
      			  <!-- <v-btn small color="primary" :to="`/visits/edit/${visit_details.id}`" >Edit</v-btn> -->
      			  <v-btn small color="primary" class="ml-3" @click="delete_visit_dialog_box=true">Delete</v-btn>
      			</v-flex>      			
      		</v-layout>
      		<v-layout row wrap>
      		  <v-flex xs12 md12 lg12 style="position: relative;">
      		  	<v-card>
      		  		<v-card-title primary-title>
      		  		Overview
      		  		</v-card-title>
      		   		<v-card-text> 
      		   		<v-layout row wrap>
                  <v-flex xs12 sm4 md4 v-if="visit_details.image">
                    <v-img :src="storage_path()+visit_details.image.path"
                    max-width="300"
                    max-height="300"
                     ></v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md4 v-else>
                    <v-img src="@/assets/images/index.png"></v-img>
                  </v-flex>
                  <v-flex xs12 sm8 md8>
                    <v-layout row wrap>
                      <v-flex xs2 md2 lg2>
                        Type:
                      </v-flex>
                      <v-flex xs4 md4 lg4 class="black--text">
                        {{ visit_details.type}}
                      </v-flex>
                      <v-flex xs2 md2 lg2>
                        Time:
                      </v-flex>
                       <v-flex xs4 md4 lg4 class="black--text">
                        {{formatDate(visit_details.time)}}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs2 md2 lg2>
                        Visitor:
                      </v-flex>
                      <v-flex xs4 md4 lg4 class="black--text" v-if="visit_details.visitor">
                        <router-link :to="{ name:'showVisitorDetails',params: { id:visit_details.visitor.id } }">{{visit_details.visitor.name}}</router-link>
                      </v-flex>
                      <v-flex xs4 md4 lg4 class="black--text" v-else>
                        -
                      </v-flex>
                      <v-flex xs2 md2 lg2>
                        Email:
                      </v-flex>
                       <v-flex xs4 md4 lg4 class="black--text">
                        {{visit_details.email}}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs2 md2 lg2 >
                        Office
                      </v-flex>
                      <v-flex xs4 md4 lg4 v-if="visit_details.office" class="black--text">
                        <router-link :to="{ name:'showOfficeDetails',params: { id:visit_details.office.id } }">{{visit_details.office.name}}</router-link>
                      </v-flex>
                      <v-flex xs4 md4 lg4 v-else>
                        -
                      </v-flex>
                      <v-flex xs2 md2 lg2 >
                        User
                      </v-flex>
                      <v-flex xs4 md4 lg4 v-if="visit_details.user" class="black--text">
                        <router-link :to="{ name:'showUserDetails',params: { id:visit_details.user.id } }">{{visit_details.user.name}}</router-link>
                      </v-flex>
                      <v-flex xs4 md4 lg4 v-else>
                        -
                      </v-flex>
                     </v-layout>
                  </v-flex>
      		   		  
      		   		</v-layout>    		     
      		   		</v-card-text> 
      		  	</v-card>      		    
      		  </v-flex>
      		</v-layout>
      		
            </v-container>
            <!-- Delete Office model -->
		      <v-dialog
		      v-model="delete_visit_dialog_box"
		      scrollable 
		      :overlay="false"
		      max-width="600px"
		      transition="dialog-transition"
		      >
		      <v-card>
		        <v-form>
		          <v-card-text>
		            <v-card-title primary-title>
		                <span>Are you sure you want to delete this Visit ?</span>
		              </v-card-title>
		          </v-card-text>
		          <v-card-actions>
		              <v-spacer></v-spacer>
		              <v-btn color="primary" small @click="deleteVisit" >Delete</v-btn>
		              <v-btn color="black" text small @click="delete_visit_dialog_box=false">Cancel</v-btn> 
		            </v-card-actions>
		        </v-form>
		      </v-card>
		      </v-dialog>
	</div>
</template>
<script>
export default{
	methods:{
		getVisitDetails:function()
		{	
			
                this.loaders.detail_loader =true;		
        	      axios.get(`${process.env.VUE_APP_API_URL}/api/visits/` +this.$route.params.id).then(response => {
	          		if(response.data.status == 1) {	            
	            		this.visit_details = response.data.visit_details;
	            		this.loaders.detail_loader = false;            		     
	          		}	          		
        		})
        		.catch(error => {
          			console.log(error);         
        		}).finally(()=>{

				});
		},
            deleteVisit()
            {  
              axios
              .post(`${process.env.VUE_APP_API_URL}/api/visits/`+ this.visit_details.id +`/delete`).then((response)=>{
                if(response.data.status ==1){
                  this.response_message = response.data.message;
                  this.delete_visit_dialog_box = false;
                  this.$router.push({ name: 'visits'});
                  
                }
                
              }).catch((error)=>{
                console.log(error);
                
              }).finally(()=>{{
                
              }});
            },
	},
	data(){
		return{
			visit_details:{
        type:'',
        image:{},
      },
			loaders:{
				detail_loader:false,
			},
      delete_visit_dialog_box:false,
      visit_related_visits:[],
      visit_headers: [
            {
            text: 'Name',
            align: 'left',
            value: 'name',
            },
            { text: 'Mobile', value: 'mobile' },
            { text: 'Email', value: 'email' },
            { text: 'Action', value: '',sortable: false, },
      ],
      is_loading:false,
      total_items:10,
      options:{},
      default_visit_image:"visits_images/index.png",
		}
	},
	mounted()
	{
		this.getVisitDetails();
	}
	};
</script>